var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoxArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100.00052mm",
    height: "86.151001mm",
    viewBox: "0 0 100.00052 86.151001",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-33.425365,-106.76904)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path846-3",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#0b357a",
      strokeWidth: 30.2362,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 188.97656 8.5898438 L 98.228516 164.95312 L 7.4785156 321.31445 L 80.048828 321.31445 L 108.64258 271.78711 L 189.90234 131.04102 L 271.16211 271.78711 L 299.75586 321.31445 L 370.47656 321.31445 L 279.72656 164.95312 L 188.97656 8.5898438 z ",
    transform: "matrix(0.26458333,0,0,0.26458333,33.425365,106.76904)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxArrow);
export default __webpack_public_path__ + "static/media/box-arrow.556d322270e9d2e253c8a2e163fa9616.svg";
export { ForwardRef as ReactComponent };